import { ComingSoonItem } from "@/components/atoms/Items/ComingSoonItem";
import { MainTemplate } from "@/components/templates/MainTemplate";
import React from "react";

const ExpertQuestionPage = () => {
  return (
    <MainTemplate>
      <ComingSoonItem />
    </MainTemplate>
  );
};

export default ExpertQuestionPage;
